export const storeTranslations = {
  STORE_TITLE: 'Download Tranzer',
  STORE_SUBTITLE: 'And in 3 easy steps from now on'
};
